var _path, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMale = function SvgIconMale(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.442,
    height: 40.059
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#707070",
    d: "M3.908 13.672a.41.41 0 0 0-.417.427v.064a7.32 7.32 0 0 0 2.25 5.09 7.49 7.49 0 0 0 5.3 2.081 7.644 7.644 0 0 0 5.564-12.739 23.9 23.9 0 0 0 6.049-6.135 35 35 0 0 0 .442 4.243c.015.061.2.108.434.108s.42-.047.434-.108v-.016A35 35 0 0 0 24.438.92a.91.91 0 0 0-.9-.92 35 35 0 0 0-5.782.491c-.061 0-.108.194-.108.422s.047.415.108.422h.015a35 35 0 0 0 4.231.447 23.8 23.8 0 0 0-6.135 6.057 7.58 7.58 0 0 0-4.893-1.816 7.5 7.5 0 0 0-5.276 2.13 7.3 7.3 0 0 0-2.209 5.1.4.4 0 0 0 .417.417.434.434 0 0 0 .442-.368v-.059a6.42 6.42 0 0 1 2.258-4.194 6.24 6.24 0 0 1 4.388-1.45 6.079 6.079 0 0 1-.059 12.143 6.26 6.26 0 0 1-4.371-1.492 6.4 6.4 0 0 1-2.209-4.211.45.45 0 0 0-.449-.368Zm18.737-11.87v.2c-.032-.037-.054-.071-.093-.11s-.076-.064-.113-.1Z",
    "data-name": "Path 1"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    fill: "#707070",
    fontFamily: "var(--font-body)",
    fontSize: 11,
    transform: "translate(12 38.059)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -11.836,
    y: 0
  }, "Male"))));
};
export default SvgIconMale;